import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../constants/HubApiMethods';
import { SetNewPasswordResponse } from '../../../api/hub-responses/set-new-password-response';

export type SetNewEmailPasswordRequest = {
    expires: number,
    email: string,
    token: string,
    password: string,
    locale: string
}

export function setNewEmailPassword(data: SetNewEmailPasswordRequest): Promise<SetNewPasswordResponse> {
    return HubJsonRpcRequest.makeRequest<SetNewPasswordResponse, SetNewEmailPasswordRequest>(
        HubApiMethods.SET_NEW_PASSWORD,
        data,
        window.app.deviceIdentifier
    );
}
